import { useEffect, useState } from "react";
import { ImageOff } from "lucide-react";
import { useEditor } from "@/components/editor/useEditorState";

// Screenshots are private (admin API): fetched with the session token and shown as object URLs.
export default function ReviewImage({ rid, name, alt = "", className = "", testid }) {
  const { api, id } = useEditor();
  const [src, setSrc] = useState(null);
  useEffect(() => {
    if (!name) return undefined;
    let url = null;
    let alive = true;
    setSrc(null);
    api.get(`/projects/${id}/visual-reviews/${rid}/img/${name}`, { responseType: "blob" })
      .then(({ data }) => { if (alive) { url = URL.createObjectURL(data); setSrc(url); } })
      .catch(() => alive && setSrc(false));
    return () => { alive = false; if (url) URL.revokeObjectURL(url); };
  }, [api, id, rid, name]);
  if (!name || src === false) {
    return <div className={`grid place-items-center gap-1 bg-slate-100 text-[11px] text-slate-400 ${className}`} data-testid={testid}><ImageOff size={16} />Non disponibile</div>;
  }
  if (!src) return <div className={`animate-pulse bg-slate-100 ${className}`} data-testid={testid} />;
  return <img src={src} alt={alt} className={className} data-testid={testid} />;
}
